import MimirService from './mimir-service';
import axios from 'axios';

let dmarcAuthCall;
let dmarcEffectivenessCall;
let domainCoverageCall;
let messageVolumeCall;

export default class ReportsService extends MimirService{

    getDmarcAuthentication( params ){
        if( dmarcAuthCall ){
            dmarcAuthCall.cancel( 'Only one request allowed at a time.' );
        }
        dmarcAuthCall = axios.CancelToken.source();
        const config = {
            cancelToken: dmarcAuthCall.token,
            params,
        };
        return this.request( '/v1/reports/dmarc-authentication', config );
    };

    getDmarcEffectiveness( params ){
        if( dmarcEffectivenessCall ){
            dmarcEffectivenessCall.cancel( 'Only one request allowed at a time.' );
        }
        dmarcEffectivenessCall = axios.CancelToken.source();

        const config = {
            cancelToken: dmarcEffectivenessCall.token,
            params,
        };

        return this.request( '/v1/reports/dmarc-effectiveness', config );
    }

    getDomainCoverage( params ){
        if( domainCoverageCall ){
            domainCoverageCall.cancel( 'Only one request allowed at a time.' );
        }
        domainCoverageCall = axios.CancelToken.source();

        const config = {
            cancelToken: domainCoverageCall.token,
            params,
        };

        return this.request( '/v1/reports/dmarc-coverage-domains', config );
    }

    getMessageVolumePolicyProgress( params ){
        if( messageVolumeCall ){
            messageVolumeCall.cancel( 'Only one request allowed at a time.' );
        }
        messageVolumeCall = axios.CancelToken.source();

        const config = {
            cancelToken: messageVolumeCall.token,
            params,
        };

        return this.request( '/v1/reports/dmarc-coverage-messages', config );
    }

    getPdf( dateRange, interval, domain, domainType, report ){
        return this.instance.post( '/v1/reports/pdf', {
            dateRange,
            domain,
            domainType,
            interval,
            report,
        },
        {
            headers: {
                Accept: 'application/pdf'
            },
            responseType: 'blob',
        } );
    }

    getImage( dateRange, interval, domain, domainType, report, chartName, dmarcPassType ){
        return this.instance.post( '/v1/reports/chart-image', {
            chartName,
            dateRange,
            dmarcPassType,
            domain,
            domainType,
            interval,
            report,
        },
        {
            headers: {
                Accept: 'image/png'
            },
            responseType: 'blob',
        } );
    }
}
